import { APPOINTMENT_STATUS } from 'features/appointment/services/constants';
import React from 'react';
import styled from 'styled-components';
type Props = {
  status?: any;
};
const AppointmentDetailV3Header = ({ status }: Props) => {
  const StatusBox = () => {
    switch (status) {
      case APPOINTMENT_STATUS.NO_SHOW:
        return (
          <div className="status-box no-show">
            <div className="circle-shape" />
            <span>No Show</span>
          </div>
        );
      case APPOINTMENT_STATUS.DELETE:
      case APPOINTMENT_STATUS.CANCEL:
        return (
          <div className="status-box cancel">
            <div className="circle-shape" />
            <span>Cancel</span>
          </div>
        );
      case APPOINTMENT_STATUS.CONFIRM:
        return (
          <div className="status-box confirm">
            <div className="circle-shape" />
            <span>Confirm</span>
          </div>
        );

      default:
        return (
          <div className="status-box">
            <div className="circle-shape" />
            <span>Appointment</span>
          </div>
        );
    }
  };

  return (
    <HeaderModal>
      <div className="modal-title">Appointment</div>
      <div className="status-container">
        <StatusBox />
      </div>
    </HeaderModal>
  );
};

export default AppointmentDetailV3Header;

const HeaderModal = styled.div`
  border-radius: 5px 5px 0px 0px;
  position: sticky;
  top:0;
  z-index: 99;
  background: #232F3E;
  padding: 0px 16px;
  max-height: 76px;
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .modal-title {
    color: #FFF;
    background: #232F3E;
    left: 50%;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }

  .status-container {
    .status-box {
      display: flex;
      align-items: center;
      gap: 8px;
      .circle-shape {
        display: flex;
        width: 32px;
        height: 32px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 100px;
        background: #6FABB6;
      }
      span {
        color: #6FABB6;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      &.confirm {
        .circle-shape {
          background: #6FE7BF;
        }
        span {
          color: #6FE7BF;
        }
      }
      &.cancel {
        .circle-shape {
          background: #F5767F;
        }
        span {
          color: #F5767F;
        }
      }
      &.no-show {
        .circle-shape {
          background: #E5E6EB;
        }
        span {
          color: #E5E6EB;
        }
      }
    }
  }
`;